import {IClassificationResource} from "../../core/services/ClassificationService"
import * as swal from "sweetalert";
import * as angular from "angular";
export class ClassificationModalComponent implements ng.IComponentOptions {
  public controller: any = ClassificationModalController;
  public bindings: any = {
    modalInstance: "<",
    resolve: "<"
  }
  public template: string =
    `<div class="modal-header">
      <button type="button" class="close" ng-click="$ctrl.cancel()" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      <h4 class="modal-title" id="classificationModal">{{$ctrl.title}}</h4>
    </div>
    <div class="modal-body">
      <form name="classificationForm" class="form-horizontal">
        <div class="form-group">
          <label for="name" class="col-sm-3 control-label">Name</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="name" placeholder="Name" ng-model="$ctrl.form.name" required>
          </div>
        </div>
        <div class="form-group" ng-show="$ctrl.isCategory">
          <label for="code" class="col-sm-3 control-label">Code</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="code" placeholder="Code" ng-model="$ctrl.form.code">
          </div>
        </div>
        <div class="form-group" ng-hide="$ctrl.isCategory">
          <label for="desc" class="col-sm-3 control-label">Description</label>
          <div class="col-sm-9">
            <textarea class="form-control" id="desc" placeholder="Description" ng-model="$ctrl.form.description"></textarea>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()">Close</button>
      <button type="button" class="btn btn-primary" ng-click="classificationForm.$valid && $ctrl.save()">Save changes</button>
    </div>`;
}
export interface IClassification extends ng.resource.IResource<any> {
  name: string;
  type: string;
  state: string;
  createdOn: Date;
}
export class ClassificationModalController {
  public static $inject: Array<any> = ["ClassificationService", "$timeout"]
  public modalInstance: ng.ui.bootstrap.IModalServiceInstance;
  public resolve: any;
  public form: any;
  public title: any;
  public isCategory: boolean;
  constructor(private ClassificationService: IClassificationResource, private $timeout: ng.ITimeoutService){
    $timeout(() => {
      this.title = this.resolve.title;
      this.isCategory = (this.resolve.type == "category" || this.resolve.type == "group")?true: false;
      if (this.resolve.classification)
        this.form = angular.copy(this.resolve.classification);
    })
  }
  public cancel() {
    this.modalInstance.dismiss("canceled");
  }
  public save() {
    if (this.form._id) {
      this.ClassificationService.update({classificationId: this.form._id}, this.form)
      .$promise.then((saved) => {
        this.modalInstance.close(saved);
      })
      .catch(() => {
        swal("Oops!",`${this.title} failed to update. Please try again`, "warning");
      })
    }
    else {
      let _classification: IClassification = new this.ClassificationService(this.form);
      _classification.type = this.resolve.type;
      _classification.$save().then((saved) => {
        this.modalInstance.close(saved);
      })
      .catch(() => {
        swal("Sorry!", "Classification failed to save, please try again", "warning");
      })
    }
  }
}
